export const sectionInfo = {
	"acceleratedreaderinfo" : {
		"category" : "bookinfo",
		"categoryLabel" : "Additional Book Info. from NoveList",
		"featureType" : "acceleratedreaderinfo"	
	},
	"relatedcontent":
		{
			"categoryLabel": "Related Content from NoveList",
			"category": "relatedcontent",
			"featureType": "relatedcontent"
		},
	"libraryaware":
		{
			"categoryLabel": "Related Content from LibraryAware",
			"category": "relatedcontent",
			"featureType": "libraryaware"
		},
	"libraryawarepost":
		{
			"categoryLabel": "Related Content from LibraryAware",
			"category": "relatedcontent",
			"featureType": "libraryawarepost"
		},
	"libraryawarenewsletter":
		{
			"categoryLabel": "Related Newsletters from LibraryAware",
			"category": "relatedcontent",
			"featureType": "libraryawarenewsletter"
		},
	"nextreads":
		{
			"categoryLabel": "Related Content from NoveList",
			"category": "relatedcontent",
			"featureType": "nextreads"
		},
	"evanced":
		{
			"categoryLabel": "Related Content from NoveList",
			"category": "relatedcontent",
			"featureType": "evanced"
		},
	"similartitles":
		{
			"categoryLabel": "Reading Recommendations from NoveList",
			"category": "suggestions",
			"featureType": "similartitles"
		},

	"similarauthors":
		{
			"categoryLabel": "Reading Recommendations from NoveList",
			"category": "suggestions",
			"featureType": "similarauthors"
		},

	"seriesinfo":
		{
			"categoryLabel": "Additional Book Info. from NoveList",
			"category": "bookinfo",
			"featureType": "seriesinfo"
		},

	"goodreads":
		{
			"categoryLabel": "Additional Book Info. from NoveList",
			"category": "bookinfo",
			"featureType": "goodreads"
		},

	"annotation":
		{
			"categoryLabel": "Additional Book Info. from NoveList",
			"category": "bookinfo",
			"featureType": "annotation"
		},

	"bookcontents":
		{
			"categoryLabel": "Additional Book Info. from NoveList",
			"category": "bookinfo",
			"featureType": "bookcontents"
		},

	"lexileinfo":
		{
			"categoryLabel": "Additional Book Info. from NoveList",
			"category": "bookinfo",
			"featureType": "lexileinfo"
		},

	"similarseries":
		{
			"categoryLabel": "Reading Recommendations from NoveList",
			"category": "suggestions",
			"featureType": "similarseries"
		},

	"eresourcerecommendation":
		{
			"categoryLabel": "Related Content from NoveList",
			"category": "relatedcontent",
			"featureType": "eResourceRecommendation"
		},
	"appeals":
		{
			"categoryLabel": "Appeal terms from NoveList",
			"category": "bookinfo",
			"featureType": "appeals"
		},
	"linktonovelist":
		{
			"categoryLabel": "Link to the NoveList interface",
			"category": "bookinfo",
			"featureType": "linktonovelist"
		},
	"linktobookchat":
		{
			"categoryLabel": "BookChat from NoveList",
			"category": "bookchat",
			"featureType": "linktobookchat"
		},
	"reviews":
		{
			"categoryLabel": "Additional Book Info. from NoveList",
			"category": "bookinfo",
			"featureType": "reviews"
		}
};



// WEBPACK FOOTER //
// ./src/data/FeatureSectionInfo.js